// @core/api/endpoints/project/move_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
  MoveItemRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Move item on board
 * Moves an item to a different board column and/or position. Status changes may trigger workflow automations and sync to the source task.
 */
export async function MoveItem(
  project_id: string,
  item_id: string,
  data: MoveItemRequest,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items/:item_id/move`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.post<ItemResponse>(requestPath, data, requestOptions);
}
